import React from 'react';
import 'Lessons/angularModule';
import { angularDirectiveToReact } from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const StreamCompleted = angularDirectiveToReact('streamCompleted', {
    streamId: '<',
});

export const StreamCompletedComponent: React.FC = () => {
    const [key, params] = useAngularToReactRoute<{
        streamId: string;
    }>();

    return <StreamCompleted key={key} {...params} />;
};
